import * as _ from 'lodash';
import { BaseObject } from './BaseObject';

export class OrganizationType extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
    }

    effectiveSortingCode() {
        // Add 'z' in case the name start with numbers
        return this.Active ? this.SortingCode : "z" + this.Name;
    }
}
